module.exports = require("npm:fastclick@1.0.6/lib/fastclick.js");